// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"TX-z","categoryName":"UX-z","categoryNameSearchHeader":"VX-z","categoryContent":"WX-z","bottomAligned":"XX-z","image":"YX-z","imageNoBackground":"ZX-z"};